import * as React from 'react';

import Workflow16 from './Workflow16';

export const workflow16 = () => <Workflow16 />;

export default {
    title: 'Icon/Fill/Workflow16',
    component: Workflow16,
    parameters: {
        notes: "`import Workflow16 from 'box-ui-elements/es/icon/fill/Workflow16';`",
    },
};
